import React, { Component } from 'react';

import styles from './styles.module.css';

import Modal from '../../../../components/Modal';
import ModalConfirm from '../../../../components/ModalConfirm';
import Header from '../../../../components/Header';
import Button from '../../../../components/Buttons/Button';

import TableRow from './Table/TableRow';

import api from '../../../../services/api';
import { API_GUARD } from '../../../../services/env';

export default class Signature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      company: {},
      signatures: [],
      marked_signature_id: "",
      isAlertOn: false,
      isExclusionConfirmOn: false,
      modalConfirm: {
        title: "",
        text: ""
      },
      alertMessage: {
        title: "",
        message: ""
      }
    }
    this.getSignatures = this.getSignatures.bind(this);
    this.toggleIsLoad = this.toggleIsLoad.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggleConfirm = this.toggleConfirm.bind(this);
  }

  componentDidMount() {
    this.getSignatures();
  }

  toggleAlert() {
    this.setState({
      isAlertOn: !this.state.isAlertOn,
    });
  }

  activeAlert(alertMessage) {
    const { title, message } = alertMessage;
    this.setState({
      ...this.state,
      isAlertOn: true,
      alertMessage: {
        title,
        message
      }
    });
  }

  toggleIsLoad(boolean) {
    this.setState({ isLoading: boolean });
  }

  async getSignatures() {
    try {
      this.toggleIsLoad(true);
      const { params } = this.props.match;
      const access_token = await localStorage.getItem("access_token");
      const url = `/v1/${API_GUARD}/company/${params.company_id}/signature`;
      const response = await api.get(url, {
        headers: { Authorization: "Bearer " + access_token }
      });
      if (response.status && response.status === 200) {
        const { company, signatures } = response.data;
        this.setState({ company, signatures });
      }
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            const { message } = error.response.data;
            this.setState({
              message
            });
            break;
          case 422:
            const { errors } = error.response.data;
            for (let key in errors) {
              this.setState({
                validate: {
                  ...this.state.validate,
                  [key]: {
                    message: errors[key],
                    isInvalid: true
                  }
                }
              });
            }
            break;
          default:
            this.error();
        }
      }
    }
    this.toggleIsLoad(false);
  }

  toggleConfirm(signature) {
    if (signature) {
      const { id } = signature;
      this.setState({
        marked_signature_id: id,
        isExclusionConfirmOn: !this.state.isExclusionConfirmOn,
        modalConfirm: {
          title: "Excluir Assinatura",
          message: `Tem certeza que deseja excluir essa assinatura?`
        }
      });
    } else {
      this.setState({
        marked_branch_id: null,
        isExclusionConfirmOn: false,
        modalConfirm: {
          title: "",
          message: ""
        }
      });
    }
  }

  handlerConfirm() {
    const id = this.state.marked_signature_id;
    this.handlerDestroySignature(id);
  }

  async handlerDestroySignature(id) {
    if (!this.state.isLoading) {
      this.toggleIsLoad(true);
      try {
        const access_token = await localStorage.getItem("access_token");
        const response = await api.delete(`/v1/${API_GUARD}/signature/${id}`, {
          headers: { Authorization: "Bearer " + access_token }
        });
        if (response.status && response.status === 200) {
          const { title, message } = response.data;
          this.activeAlert({ title, message });
        }
        this.getSignatures()
      } catch (error) {
        if (error.response) {
          const { data } = error.response;
          const { errors } = data;
          switch (error.response.status) {
            case 400:
              this.activeAlert({ title: data.title, message: data.message });
              break;
            case 404:
              this.activeAlert({ title: data.title, message: data.message });
              break;
            case 422:
              for (let key in errors) {
                this.setState({
                  validate: {
                    ...this.state.validate,
                    [key]: {
                      message: errors[key],
                      isInvalid: true
                    }
                  }
                });
              }
              break;
            default:
              this.error();
          }
        }
        this.toggleIsLoad(false);
      }
    }
  }

  error() {
    const alert = {
      title: "Ops... Algo deu errado.",
      message: "Não foi possível completar sua requisição."
    }
    this.activeAlert(alert);
  }

  handlerHeaderSignatureCreate() {
    const { history } = this.props;

    history.push(`/admin/company/${this.state.company.id}/assinaturas/adicionar`);
  }

  render() {
    const { isLoading, signatures } = this.state;
    return (
      <div className={`${styles.container}`}>
        <Header title="Assinaturas" description="Assinaturas cadastradas" />
        <div className={`${styles.body} ${styles.shadowBox}`}>
          <div className={styles.tableHeader}>
            <div className={styles.tableTitle}>
              <h2>Listagem de Assinaturas: {this.state.company.name ?
                `${this.state.company.name} (${this.state.company.code})`
                : "Carregando..."}</h2>
            </div>
            <br />
            <div className={styles.tableOption}>
              <Button text='Voltar' arrowLeft={true}  onClick={this.props.history.goBack}/>
              <Button text="Adicionar"
                type="button"
                onClick={() => { this.handlerHeaderSignatureCreate() }}
              />
            </div>
          </div>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>PABX</th>
                <th>Assinatura</th>
                <th className="d-none d-lg-table-cell">Data início</th>
                <th className="d-none d-lg-table-cell">Data Fim</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {
                isLoading ? (
                  <tr>
                    <th colSpan="6">Carregando listagem...</th>
                  </tr>
                ) :
                  !(signatures.length > 0) ? (
                    <tr>
                      <th colSpan="6">Nenhum registro encontrado.</th>
                    </tr>
                  ) :
                    signatures.map((signature, key) => (
                      <TableRow
                        history={this.props.history}
                        match={this.props.match}
                        key={key}
                        item={signature}
                        id={key}
                        toggleConfirm={(signature) => this.toggleConfirm(signature)}
                      />
                    ))
              }
              {/* this.toggleConfirm(signature) */}
            </tbody>
          </table>
          <Modal
            isActive={this.state.isAlertOn}
            toggleAlert={this.toggleAlert}
            title={this.state.alertMessage.title}
            text={this.state.alertMessage.message}
          />
          <ModalConfirm
            isActive={this.state.isExclusionConfirmOn}
            toggleConfirm={this.toggleConfirm}
            handlerConfirm={() => { this.handlerConfirm(); this.toggleConfirm(null) }}
            title={this.state.modalConfirm.title}
            text={this.state.modalConfirm.message}
          />
        </div>
      </div>
    );
  }
}
